export default __webpack_public_path__ + "static/media/content_tab04_2_03.52b82d55.png";